var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraduationcap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "62627") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workforce-new-home-taxonomy-v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WorkForce_new_Landing_search-suggestiontv3",
    transform: "translate(-206.000000, -654.000000)",
    fill: "#4F4A46",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(121.000000, 550.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 62627,
    transform: "translate(85.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "18.8224556 4.97175 18.8224556 4.55723333 9.40710556 0.0218166667 0 4.55322778 0 4.97567778 9.40710556 9.50720556"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2592,7.37216667 L3.2592,10.0827611 L8.9306,12.8147056 L9.88361111,12.8147056 L15.5394167,10.0902667 C15.5448611,10.0783278 15.5499556,10.0664278 15.55505,10.0544111 L15.55505,7.37216667 L9.40710556,10.3336333 L3.2592,7.37216667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "17.8307889 11.5186944 17.8307889 6.24551667 17.0861833 6.62102778 17.0861833 11.5186944 16.6010056 12.9967833 17.3344111 13.9784167 17.5825611 13.9784167 18.3159278 12.9967833"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationcap);
export default __webpack_public_path__ + "static/media/graduationcap.83b4f2a85818f451a2ee6548755eb5a2.svg";
export { ForwardRef as ReactComponent };